var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeatpost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 613 613",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 23 523 C 138 410 253 298 370 184 359 175 350 167 340 159 365 135 386 114 409 92 450 127 490 160 531 195 511 215 491 235 471 253 466 257 455 256 451 252 442 242 434 244 416 261 313 362 209 463 106 564 101 569 96 574 90 579 67 560 46 543 23 523 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 428 74 C 441 60 454 47 468 34 508 68 550 101 591 136 578 151 565 164 551 178 509 143 469 108 428 74 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeatpost);
export default __webpack_public_path__ + "static/media/seatpost.f6c9087caabdc02e325a6330731a8204.svg";
export { ForwardRef as ReactComponent };